import { render, staticRenderFns } from "./part.vue?vue&type=template&id=fdad9bb2&scoped=true&"
import script from "./part.vue?vue&type=script&lang=js&"
export * from "./part.vue?vue&type=script&lang=js&"
import style0 from "./part.vue?vue&type=style&index=0&id=fdad9bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdad9bb2",
  null
  
)

export default component.exports